module.exports = __webpack_public_path__ + "static/media/user.6c6459e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Menu/user.png
// module id = 2059
// module chunks = 0